import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// Components 

import Box from '@mui/material/Box';

interface Props { 
    children: React.ReactNode; 
    containerExtraStyle?: any; 
    popupExtraStyle?: any; 
    containerHander?: any; 
    containerChildren?: any; 
}; 

const Popup: React.FC<Props> = ({ children, containerExtraStyle, popupExtraStyle, containerHander, containerChildren }) => {

    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 

    const colors = useAppSelector(state => state.theme.colors); 

    // -- 

    const handleAction = () => { 

        if (containerHander) { 

            containerHander(); 

        } else { 

            return; 

        }; 

    }; 

    // -- 

    return (

        <Box 
            onClick={handleAction}
            sx={[{ 
                display: 'flex', 
                flexDirection: 'column',
                alignItems: 'center', 
                justifyContent: 'space-evenly',
                width: '100vw',
                height: '100vh', 
                backgroundColor: colors?.popup, 
                overflow: 'hidden', 
                position: 'absolute', 
                zIndex: 100000000,
        }, containerExtraStyle]}>

            <Box
                sx={[{ 
                    display: 'flex', 
                    flexDirection: 'column',
                    alignItems: 'center', 
                    justifyContent: 'space-evenly',
                    textAlign: 'center', 
                    minWidth: '25vw', 
                    position: 'absolute', 
                    padding: 3, 
                    borderRadius: 5,
                    fontSize: 14,
                    color: colors?.text, 
                    backgroundColor: colors?.container,
                }, popupExtraStyle]}
            >

                {children}

            </Box>

            {containerChildren}

      </Box>

  );

};

export default Popup;